import { render, staticRenderFns } from "./2025-10-1.vue?vue&type=template&id=9a3a2fe2&scoped=true&"
import script from "./2025-10-1.vue?vue&type=script&lang=ts&"
export * from "./2025-10-1.vue?vue&type=script&lang=ts&"
import style0 from "./2025-10-1.vue?vue&type=style&index=0&id=9a3a2fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3a2fe2",
  null
  
)

export default component.exports